
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/for-agencies",
      function () {
        return require("private-next-pages/solutions/for-agencies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/for-agencies"])
      });
    }
  